import React, { useContext } from 'react';
import { VsCodeAuthContext } from '../../contextApis/vsCodeAuthContext';
import { LoadingSpinner } from '../ui/LoadingSpinner';
import sixthLogo from '../../assets/icon.svg';
import { motion } from 'framer-motion';

const AuthLayout = ({ children }) => {
  const { loading } = useContext(VsCodeAuthContext);

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white font-sans overflow-hidden relative flex flex-col items-center justify-center p-4">
      {/* Background Orbs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <motion.div 
          animate={{ x: [0, 20, -20, 0], y: [0, -20, 20, 0], scale: [1, 1.1, 0.9, 1] }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
          className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-[120px]"
        />
        <motion.div 
          animate={{ x: [0, -30, 20, 0], y: [0, 30, -30, 0], scale: [1, 0.9, 1.1, 1] }}
          transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
          className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-purple-600/10 rounded-full blur-[80px]"
        />
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md relative z-10"
      >
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-primary/20 to-purple-600/20 rounded-2xl flex items-center justify-center border border-primary/20 backdrop-blur-sm shadow-xl shadow-primary/10">
            <img src={sixthLogo} alt="Sixth AI" className="w-8 h-8 drop-shadow-[0_0_8px_rgba(224,5,255,0.5)]" />
          </div>
        </div>

        <div className="bg-[#121219]/90 backdrop-blur-xl border border-white/10 rounded-xl shadow-2xl p-8 relative overflow-hidden">
          {loading && (
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center">
              <LoadingSpinner />
            </div>
          )}
          {children}
        </div>

        <div className="mt-8 text-center">
          <a href="#" className="text-xs text-muted-foreground hover:text-primary transition-colors">
            Terms of Service and Privacy Policy
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default AuthLayout;
